$(document).ready(function () {
  $('.v_gao').on('click', function () {
  })

  // Make sure that one item keeps open in accordion
  const accordions = document.querySelectorAll(".accordion-collapse");

  let opening = false;
  accordions.forEach(function (el) {
    el.addEventListener("hide.bs.collapse", (event) => {
      if (!opening) {
        event.preventDefault();
        event.stopPropagation();
      } else {
        opening = false;
      }
    });
    el.addEventListener("show.bs.collapse", (event) => {
      opening = true;
    });
  });

  let accordion_top_content_block = document.querySelector(".accordion_top_content_block");

  let mobileCloseBtn = document.querySelector(".cross_bar");
  let mobileOpenBtn = document.querySelector(".mobile_bars");
  let mobileMenu = document.querySelector(".mobile_slide_menu");
  // for price box  



  // for mobile menu close 

  mobileOpenBtn.addEventListener("click", function () {
    mobileMenu.classList.add("active");

  });

  mobileCloseBtn.addEventListener("click", function () {
    mobileMenu.classList.remove("active");

  });

  $('.card-header').click(function () {
    $(this).find('i').toggleClass('fas fa-plus fas fa-minus');
  });

  $('.multiple_items').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  });

  $('.warrior_items').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  });

    $('#collapseOne').on('show.bs.collapse', function (e) {
        accordion_top_content_block.classList.remove("active");
    });
    $('#collapseThree').on('show.bs.collapse', function (e) {
        accordion_top_content_block.classList.remove("active");
    });

    $('#collapseTwo').on('hidden.bs.collapse', function (e) {
        accordion_top_content_block.classList.remove("active");
    });
    $('#collapseTwo').on('show.bs.collapse', function (e) {
        accordion_top_content_block.classList.add("active");
    });

    try {
        //One time, Monthly tab
        var onetimeTab = document.querySelector('button[id="onetime-tab"]')
        onetimeTab.addEventListener('shown.bs.tab', function (event) {
            $('[name="billing_type"]').val('onetime')
        })

        var monthlyTab = document.querySelector('button[id="monthly-tab"]')
        monthlyTab.addEventListener('shown.bs.tab', function (event) {
            $('[name="billing_type"]').val('monthly')
        })
  } catch (e) {
    console.log(e)
  }
});


$(function () {


    let subscription = localStorage.getItem('subscription')

    if (! (subscription !== null && subscription !== undefined && parseInt(subscription) > 0)) {
        setTimeout(function () {
            $('.jq-popup-subscription').fadeIn()
        }, 1500);
    }

    $('body').on('click', '.jq-close-popup', function(event) {
        event.preventDefault();
        $(this).parents('.jq-popup').fadeOut();
    });

    $('body').on('click', '.jq-subscribe-btn', function(event) {
        event.preventDefault();

        let form = $(this).parents('form')
        let btn = $(this);
        let text = btn.text()

        let data = {
            email: form.find('[name="email"]').val(),
            phone: form.find('[name="phone"]').val(),
            name: form.find('[name="name"]').val(),
            task: 'subscribe'
        };

        if (! validateEmail(('' + data.email))) {
            alert('Invalid Email')
            return;
        }

        if (('' + data.phone).length < 10) {
            alert('Invalid phone number')
            return;
        }

        if (('' + data.name).length < 2) {
            alert('Your Full name is required')
            return;
        }

        $.busyLoadFull('show')

        btn.text('Loading..')
        btn.attr('disabled', true)

        $.ajax({
            url: '/subscriber',
            type: 'POST',
            dataType: 'JSON',
            data: data,
        })
        .done(function(response) {
            localStorage.setItem('subscription', response.contact)
            form.parents('.popup').find('.jq-hide-after').hide(0)
            form.parents('.popup').find('.jq-success').removeClass('d-none')
        })
        .fail(function(response) {
            let message = response.responseJSON !== null && response.responseJSON !== undefined && response.responseJSON.message !== null
                ? response.responseJSON.message
                : 'Something went wrong, please try again later.';

            alert(message)
        })
        .always(function(response) {
            btn.text(text)
            btn.attr('disabled', false)

            $.busyLoadFull('hide')
        });
        
    });

    $('body').on('click', '.jq-go-to', function(event) {
        event.preventDefault();
        let target = $(this).attr('href')
        $([document.documentElement, document.body]).animate({
            scrollTop: $(target).offset().top
        }, 0);

        $(target).shake();
    });
})

window.getDivData = function (selector) {

    let div = $(selector + ' input, ' + selector + ' select')

    let data = {}

    $.each(div, function(index, val) {

        if (val.value === '') {
            return true;
        }

        data[val.name] = val.value
    });

    return data;
}


window.priceCng = function (index) {
    var tabButtons = document.querySelectorAll(".price_box");

    $('.price_box').removeClass('border border-dark jq-active shadow')
    
    let btn = tabButtons[index];

    $(btn).addClass('border border-dark jq-active shadow');

    // btn.style.border = "1px solid #000";
    var priceBox = $(`.v_gao:nth-child(${index + 1})`)[0];
    $(priceBox).trigger('click');

    let container = $(btn).parents('.jq-price-box')
    let otherPriceContainer = $(btn).parents('.tab-pane').find('.jq-other-amount-container')

    let value = $(btn).text().replace('$', '').toLowerCase();

    $('[name="amount"]').val(value)

    if (value !== 'other') {
        container.fadeIn(0)
        otherPriceContainer.fadeOut(0)
        otherPriceContainer.find('.jq-other-amount').val('')
    } else {
        otherPriceContainer.fadeIn(0)
        container.fadeOut(0)
        $('[name="amount"]').val('')
    }
};


let accTabCon = document.querySelector(".accordion_top_content_block");
let tab_one = document.querySelector('#collapseOne');
let tab_two = document.querySelector('#collapseTwo');
let tab_three = document.querySelector('#collapseThree');

window.nextBtn = function (index) {

    let selector = '';

    if (parseInt(index) <= 1) {
        selector = '#' + $('[onclick="nextBtn('+index+')"]').parents('.tab-pane').attr('id')
    }

    if (parseInt(index) === 2) {
        selector = '.billing_forms_block'
    }
    
    let data = getDivData(selector)

    if (parseInt(index) <= 2 && Object.keys(data).length === 0) {
        alert('Please fill this form');
        return;
    }

    if (index == 0 || index == 1) {
        tab_one.classList.remove("show");
        tab_two.classList.add("show");
        accTabCon.classList.add("active");
    }

    if (index == 2) {
        tab_two.classList.remove("show");
        accTabCon.classList.remove("active");
        tab_three.classList.add("show");
    }
}

window.validateEmail = function (value) {
    return value.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
}

jQuery.fn.shake = function(interval,distance,times){
   interval = typeof interval == "undefined" ? 100 : interval;
   distance = typeof distance == "undefined" ? 10 : distance;
   times = typeof times == "undefined" ? 3 : times;
   var jTarget = $(this);
   jTarget.css('position','relative');
   for(var iter=0;iter<(times+1);iter++){
      jTarget.animate({ left: ((iter%2==0 ? distance : distance*-1))}, interval);
   }
   return jTarget.animate({ left: 0},interval);
}